<template>
  <div class="jobs column">
    <div class="title row">
      <div class="g12 row ac js">
        <div class="g3">Meus <b>Jobs</b></div>
        <input
          v-model="filter"
          placeholder="Pesquisar"
          style="width: 250px;"
        />
      </div>

      <!-- <select class="filter">
        <option type="text">ordenando por SLA</option>
      </select>-->
    </div>

    <div
      v-if="!jobs.length && !this.loader"
      class="jobs-empty column align-center justify-center"
    >
      <img src="../assets/img/error.svg" alt="erro" />
      <div class="jobs-empty-text">
        Você ainda não possui
        <br />
        <strong>Meus Jobs</strong>
      </div>
    </div>

    <div class="jobs-list column" v-else>
      <transition-group name="fade">
        <JobRow v-for="job in filteredJobs" :job="job" :key="`job-${job.id}`" />
      </transition-group>
    </div>

    <div v-if="loader" class="jobs-loader column align-center justify-center">
      <Loader />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loader from "@/components/Loader";
import JobRow from "@/components/JobRow";
export default {
  name: "Jobs",
  components: { Loader, JobRow },
  methods: {
    ...mapActions("jobs", ["LOAD_JOBS"]),
  },
  data() {
    return {
      loader: true,
      filter: "",
    };
  },
  mounted() {
    this.LOAD_JOBS().then(() => (this.loader = false));
  },
  computed: {
    ...mapGetters("jobs", ["jobs"]),
    filteredJobs() {
      const p = this.filter.trim().toLowerCase();
      if (!p) return this.jobs;
      const fields = ["id", "id_cliente", "nome_doutor", "problema", "logradouro", "codigo_chamado_cliente"];
      return this.jobs.filter((job) =>
        fields.some((field) => String(job[field] || "").toLowerCase().includes(p))
      );
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;
.jobs {
  background: $white;
  box-shadow: $shadow;
  border-radius: 23px;
  height: 600px;

  .title {
    @media (max-width: $small) {
      padding: 16px 21px;
      text-align: center;
    }
    padding: 32px 35px;
    font-size: 26px;
    font-weight: 400;
  }
  &-empty {
    height: 45vh;
    &-text {
      margin-top: 28px;
      font-size: 18px;
      color: $gray-1;
      text-align: center;
    }
  }
  &-loader {
    height: 35vh;
  }
  &-list {
    padding-bottom: 35px;
    overflow: auto;
  }
}
</style>
